var _rect, _line, _line2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    x: 4,
    y: 2,
    rx: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 16,
    y1: 6,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 16,
    y1: 14,
    y2: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14h.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18h.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.d798026244a0f278316cba574f8604fb.svg";
export { ForwardRef as ReactComponent };